export default "__VITE_ASSET__BAb5siDD__"